import React, {useState, useEffect} from 'react'
import '../../pages/Portfolio/Portfolio.scss'
import {Fade, Slide} from 'react-reveal'

import {MDBModal, MDBModalBody, MDBModalHeader} from "mdbreact";
import cogoToast from "cogo-toast";
import CancelOrderMutation from "../../mutations/CancelOrderMutation";
import {getFormattedDate, isNanHandler, toTitle} from "../../util";
import {Link} from "react-router-dom";
import {numberFormat} from "../../util";
import {assetUrl} from "../../serviceApi";
import Skeleton from "react-loading-skeleton";
import {portfolioTabToggler} from "../../Actions";
import {connect} from "react-redux";

const politician = assetUrl + "images/politician.png";
const more = assetUrl + 'images/More.svg'
const cancelArrow = assetUrl + 'images/icon_red_right_arrow.svg'
const cross = assetUrl + 'images/close-icon-grey.png'
const arrow = assetUrl + 'images/icon_right_white_arrow.svg'
const info = assetUrl + 'images/icon_info_grey.svg'
const ProfilePic = assetUrl + "images/profile-icon.svg";
const ArrowDown = assetUrl + "images/arrow-down-purple-sm.svg";

const HoldingsAndOrders = (props) => {
	const portfolio = "portfolio-"
	const [activeTab, setActiveTab] = useState("");
	const [pendingOrderState, setPendingOrderState] = useState([]);
	const [filter, setFilter] = useState("");
	const [orderOptions, setOrderOptions] = useState({});
	const [BottomModal, setBottomModal] = useState(false);
	const [filterDropDown, setFilterDropDown] = useState(false)
	const [loading, setLoading] = useState(false);
	const [selectedOrder, setselectedOrder] = useState({});

	const {
		Componentloading,
		currentHoldings,
		pendingOrders,
		filterOrderStatus,
		filterOrderValue,
		stock_owned_count,
		stock_history_details,
		portfolioHoldingTab
	} = props;

	useEffect(() => {
		setActiveTab(portfolioHoldingTab)
	}, []);

	useEffect(() => {
		setPendingOrderState(pendingOrders)
		setFilter(filterOrderValue)

	}, [filterOrderValue]);

	const cancelOrder = () => {
		let variable = {
			orderId: selectedOrder.id
		}
		setLoading(true);
		CancelOrderMutation(variable, function (response) {
			setLoading(false);
			if (response.cancelOrder.message) {
				cogoToast.success(response.cancelOrder.message, {position: 'top-center'});
				setBottomModal(false);

			}
		}, function (err) {
			setLoading(false);
			cogoToast.error(err, {position: 'top-center'});
		});
	}

	const initCancelOrder = (item) => {

		setBottomModal(true);
		setselectedOrder(item);
		setOrderOptions({});
	}

	const filterChange = (value) => {
		// setActiveTab("current")
		filterOrderStatus(value)
		setFilterDropDown(false)

	}
	let currentHoldingListings = currentHoldings.length > 0 && currentHoldings.map(items => {

		let stockOwnedCount
		let priceDiff
		let priceDiffPercentage
		if (stock_owned_count) {
			for (let i in Object.keys(stock_owned_count)) {
				if (items.node && items.node.stock.id === Object.keys(stock_owned_count)[i]) {
					stockOwnedCount = Object.values(stock_owned_count)[i]
				}
			}
		} else {
			stockOwnedCount = 0
		}
		if (stock_history_details) {
			for (let i in stock_history_details) {
				let stock_history_details_id = stock_history_details[i]
				// console.log(stock_history_details_id)

				if (items.node && items.node.stock.id === stock_history_details_id.stock_id) {
					priceDiff = stock_history_details_id.price_diff !== null ? stock_history_details_id.price_diff : 0
					priceDiffPercentage = stock_history_details_id.price_diff_percentage !== null ? stock_history_details_id.price_diff_percentage : 0
					// console.log("stockhistory",priceDiffPercentage )
				}

			}
		}

		return (

			<div key={items.node.stock.id}>
				{/*<Fade bottom cascade delay={500}>*/}
				<div className={portfolio + "list-item"}>
					<div
						className={" d-flex justify-content-between"}>
						<Link
							className={'d-flex justify-content-between align-items-center'}
							to={"/stock-detail/" + items.node.stock.id}>
							<img
								src={items.node.stock.politicianImage ? items.node.stock.politicianImage : ProfilePic}
								alt={'alt'}
								className={portfolio + "list-item-image "}/>
							<div className={'stock-description'}>
								<div className={'d-flex align-items-start'}>
									<p className={portfolio + "list-name"}>{items.node.stock.name}</p>

								</div>
								<div className={'d-flex align-items-center'}>
									<p className={portfolio + "itemparty"}>{items.node.stock.party.partyName}</p>
									{/*stockOwned change*/}
									{
										stockOwnedCount > 0 &&
										<div className={'divider'}/>
									}
									{
										stockOwnedCount > 0 &&
										<p className={portfolio + "list-subText"}>
																<span
																	style={{
																		fontWeight: 600,
																		marginRight: "3px",
																		color: "#717178"
																	}}>{stockOwnedCount} </span>{stockOwnedCount > 1 ? "Shares " : "Share "}
											owned</p>
									}

								</div>

							</div>
						</Link>
						<div key={items.node.stock.id}>
							<div className={portfolio + "list-priceWrap text-right"}>
								<p className={portfolio + "list-priceMain"}>
									{numberFormat(items.node.stock.price)}</p>

								{
									!items.node.stock.upcoming &&
									<p className={(portfolio + "list-priceSub ") + (priceDiffPercentage >= 0 ? "positive " : "negative")}>
										{
											priceDiffPercentage !== null &&
											priceDiffPercentage >= 0 ? "+" : ""
										}
										{isNanHandler(priceDiffPercentage)}%</p>
								}

							</div>
						</div>
					</div>
					<div className={"stock-divider"}/>
					<div className={'d-flex justify-content-between'}>
						<div className={"d-flex"}>
							<p className={portfolio + "list-subText"}>Avg. Price </p>
							<span
								className={"sub-price"}>{numberFormat(items.node.averagePrice)}</span>
						</div>
						<div className={"d-flex"}>
							<p className={portfolio + "list-subText"}>Invested </p>
							<span
								className={"sub-price"}>{numberFormat(items.node.currentHoldingsInvested)}</span>
						</div>
					</div>
				</div>

			</div>

		);
	})

	let pendingOrderListings = pendingOrders.length > 0 ? pendingOrders.map(items => {
		let orderStatus = items.node.orderStatus;

		// console.log(toTitle(`${orderStatus.replace(/_/g, ' ')}`))
		return (
			<div key={items.node.stock.id} className={portfolio + "list-item"}>
				{/*<Fade bottom>*/}
				<div key={items}
				     className={" d-flex justify-content-between"}>
					<Link
						className={'d-flex justify-content-between align-items-center'}
						to={"/stock-detail/" + items.node.stock.id}>
						<img src={items.node.stock.politicianImage ? items.node.stock.politicianImage : ProfilePic}
						     alt={'alt'}
						     className={portfolio + "list-item-image "}/>
						<div className={'stock-description'}>
							<p className={portfolio + "list-name"}>{items.node.stock.name}</p>
							<div className={'d-flex align-items-center'}>
								<p className={portfolio + "itemparty"}>{items.node.stock.party.partyName}</p>
								{
									items.node.pendingStockCount > 0 &&
									<hr className={'divider'}/>
								}
								{
									items.node.pendingStockCount > 0 &&
									<p className={portfolio + "list-subText"}><span
										style={{
											fontWeight: 600,
											marginRight: "3px",
											color: "#717178"
										}}>{isNanHandler(items.node.pendingStockCount)} </span>Shares
										owned
									</p>
								}

							</div>

						</div>
					</Link>
					<div>
						<div
							className={portfolio + "list-priceWrap text-right d-flex align-items-center"}>

							<p className={portfolio + "list-priceMain mb-0"}>
								{numberFormat(items.node.stock.price)}</p>
							<div className={"position-relative"}>
								<img src={more} alt={"alt"} style={{marginLeft: "3px"}}
								     onClick={() => setOrderOptions(items.node)}/>
								{/*     cancel order */}

							</div>

						</div>
					</div>
				</div>
				<div className={"stock-divider"}/>
				<div className={'d-flex justify-content-between'}>
					<div className={"d-flex"}>
						<p className={portfolio + "list-subText"}>Buy Target Price </p>
						<span
							className={"sub-price"}>{items.node.stockPrice ? numberFormat(items.node.stockPrice) : 0}</span>
					</div>
					{items.node.orderType !== "SELL" &&
					<div className={"d-flex"}>
						<p className={portfolio + "list-subText"}>Invested </p>
						<span
							className={"sub-price"}>{items.node.pendingInvested ? numberFormat(items.node.pendingInvested) : 0}</span>
					</div>
					}
				</div>
				<div className={"text-left"}>
					{/*<p className={portfolio + "orderStatus " + (pendingOrderStatus[0].toLowerCase())}>{pendingOrderStatus[0] + " " + (pendingOrderStatus[1] ? pendingOrderStatus[1] : "")}</p>*/}
					<p className={portfolio + "orderStatus " + orderStatus.toLocaleLowerCase()}>{toTitle(orderStatus.replace(/_/g, ' '))}</p>
				</div>
				{/*</Fade>*/}
			</div>
		);
	}) : undefined

	return (
		<div className={"current-holding-and-pending-order-section"}>
			<div style={{padding: "0 24px"}}>
				<div className={portfolio + "performance-tab d-flex "}>
					<div onClick={() => {
						return (
							setActiveTab("current"),
								props.setPorfolioHoldingTabToStore("current")
						)
					}}
					     className={activeTab === "current" ? portfolio + "tabWrap-active tab-content" : portfolio + "tabWrap tab-content"}>
						<p className={portfolio + "tab-text "}>Current Holdings</p>
						<span className={portfolio + "tab-underline mt-0 mb-1"}/>
					</div>
					<div onClick={() => {
						return (
							setActiveTab("pending"),
								props.setPorfolioHoldingTabToStore("pending")
						)
					}}
					     className={activeTab === "pending" ? portfolio + "tabWrap-active tab-content" : portfolio + "tabWrap tab-content"}>
						<p className={portfolio + "tab-text "}>Pending Orders</p>
						<span className={portfolio + "tab-underline  mt-0 mb-1"}/>
					</div>
				</div>
				{activeTab !== "current" &&
				<div className="select-dropdown d-flex align-items-center"
				     onClick={() => setFilterDropDown(!filterDropDown)}>
					{/* select filter*/}
					<label className="m-0 mr-1">Order Type: </label>

					{/*<select className={portfolio + "holdings-filter"} value={filter}*/}
					{/*        onChange={(e) => filterChange(e.target.value)}>*/}
					{/*	<option value={""}>All</option>*/}
					{/*	<option*/}
					{/*		value={"PENDING"}>{"Pending"}</option>*/}
					{/*	<option*/}
					{/*		value={"PARTIALLY_COMPLETED"}>{"Partially Completed"} </option>*/}

					{/*</select>*/}
					<p className={"pending-filter-name mb-0"}>{filterOrderValue === "" ? " All " : filterOrderValue === "PARTIALLY_COMPLETED" ? " Partially Completed " : ` ${(filterOrderValue).toLowerCase()} `}</p>
					{filterDropDown && <div className={"select-box"}>
						<p className={"option-item"} onClick={() => filterChange("")}>All</p>
						<p className={"option-item"} onClick={() => filterChange("PENDING")}>Pending</p>
						<p className={"option-item mb-0"} onClick={() => filterChange("PARTIALLY_COMPLETED")}>Partially
							Completed</p>
					</div>}
					<img src={ArrowDown} alt={"ArrowDown"}/>
				</div>
				}
			</div>

			<div className={'orders-list-section'}>

				<div className={portfolio + "list-item-wrap"}>
					{/* holding list*/}
					{
						activeTab === "current" &&

						<div style={{paddingTop: "24px"}}>

							{
								Componentloading ?
									<div className={'px-4 py-3'}>
										<Skeleton count={2} height={"50px"}/>
									</div>
									:
									currentHoldings.length > 1 && currentHoldingListings !== undefined ?
										// <Fade top cascade delay={500}>
										<>
											{currentHoldingListings}
										</>
										:
										currentHoldings.length === 1 ?
											currentHoldingListings
											:
											<div className={"error-section"}>No Shares Bought Yet</div>
							}
							{/*</Fade>*/}
						</div>
					}

					{/* pending list*/}
					{
						activeTab === "pending" &&
						// <Slide right cascade></Slide>
						<div>

							{
								pendingOrders.length > 1 && pendingOrderListings !== undefined ?
									<div>
										{pendingOrderListings}
									</div> :
									pendingOrders.length === 1 ? pendingOrderListings :
										<div className={"error-section"}>No Pending Orders</div>
							}
						</div>

					}
				</div>
			</div>
			{/* order option modal for pending list */}
			<div className={"cancel-modal-wrap"}>
				<MDBModal noClickableBodyWithoutBackdrop={false} inline={false} overflowScroll={true}
				          position={"bottom"}
				          isOpen={BottomModal}>
					<MDBModalHeader>
						<div className={portfolio + "bottom-cancel-modal w-100"}>
							<div className={"d-flex justify-content-between align-items-center"}>
								<p className={"title mt-1 mb-0"}>Cancel Order</p>
								<img src={cross} alt={"alt"}
								     onClick={() => setBottomModal(false)}/>
							</div>
						</div>
					</MDBModalHeader>
					<MDBModalBody className="cancel-order-modal-body">
						<div className={portfolio + "bottom-cancel-modal"}>
							{/*<div className={"d-flex justify-content-between align-items-center"}>*/}
							{/*	<p className={"title my-1"}>Cancel Order</p>*/}
							{/*	<img src={cross} alt={"alt"}*/}
							{/*	     onClick={() => setBottomModal(false)}/>*/}
							{/*</div>*/}
							{/*<div className={"stock-divider"} />*/}
							<div className={"cancel-content"}>
								<div className={" d-flex justify-content-between "}>
									<div className={'d-flex justify-content-between'}>
										<img
											src={selectedOrder.stock && selectedOrder.stock.politicianImage ? selectedOrder.stock.politicianImage : ProfilePic}
											alt={'alt'}
											className={portfolio + "list-item-image "}/>
										<div className={'stock-description'}>
											<div className={'d-flex align-items-start'}>
												<p className={portfolio + "list-name"}>
													{selectedOrder.stock ? selectedOrder.stock.name : ""}
												</p>
											</div>
											<div className={'d-flex align-items-center'}>
												<p className={portfolio + "itemparty"}>
													{selectedOrder.stock ? selectedOrder.stock.party.partyName : ""}
												</p>
											</div>
										</div>
									</div>
									<div>
										<div className={portfolio + "list-priceWrap text-right"}>
											<p className={portfolio + "list-priceMain"}>
												{selectedOrder.stock ? numberFormat(selectedOrder.stock.price) : ""}

											</p>
										</div>
									</div>
								</div>
								{/*<div className={"d-flex stock-left-section"}>*/}
								{/*	<p className={'stock-left-value'}>34%</p>*/}
								{/*	<p className={'stock-left-text'}>Stock Left</p>*/}

								{/*</div>*/}
								{/*<div className={"percent-line-bg d-flex justify-content-start"}>*/}
								{/*	<hr className={'percent-line'}/>*/}
								{/*</div>*/}
								<div className={"stock-divider"} style={{margin: "16px 0 24px 0"}}/>

							</div>
							<div className={"cancel-description text-center"}>
								<p className={'sub-title'}>stock QUANTITY Subscribed</p>

								<p className={'value'}>{selectedOrder.quantity}</p>
								<p className={'confirmation-query'}>Are you sure you want to cancel this order?</p>
								<p className={'confirmation-description'}>{`You will be cancelling ${selectedOrder.quantity} ${selectedOrder.quantity > 1 ? "shares" : "share"} of ${selectedOrder.stock && selectedOrder.stock.name}`}</p>

							</div>
							<div className={"cancel-footer d-flex justify-content-between align-items-center"}>
								<div className={"invisible"}>
									<div className={"d-flex align-items-center"}>
										<p className={'refund-text'}>REFUND</p>
										<img src={info} alt={"alt"}/>
									</div>
									<p className={'refund-value'}>₹ 14,891</p>
								</div>
								<button
									className={"cancel-order d-flex justify-content-between align-items-center"}
									onClick={cancelOrder}
									disabled={loading}
								>
									<p className={'refund-button'}>Cancel Order</p>
									<img src={arrow} alt={"alt"}/>
								</button>
							</div>

						</div>
					</MDBModalBody>
				</MDBModal>
			</div>

			{/* cancel order	*/}
			<div className={"cancel-modal-tooltip-wrap"}>
				<MDBModal inline={false} noClickableBodyWithoutBackdrop={false} overflowScroll={true} size={"sm"}
				          isOpen={Object.keys(orderOptions).length !== 0}>
					<MDBModalBody className={"cancel-modal-tooltip"}>

						<div className={portfolio + "order-option"}>
							<div
								className={"d-flex justify-content-between align-items-center"}>
								<p className={"title"}>Order Details</p>
								<img src={cross} style={{width: "10px"}}
								     alt={"alt"}
								     onClick={() => setOrderOptions({})}/>
							</div>
							<hr className={"stock-divider"}/>
							<div className={'d-flex justify-content-between'}>
								<p className={"name"}>Purchase Date:</p>
								<p className={"value"}>{getFormattedDate(orderOptions.created)}</p>
							</div>
							<div className={'d-flex justify-content-between'}>
								<p className={"name mb-0"}>Allotment Date:</p>
								<p className={"value"}>{getFormattedDate(orderOptions.edited)}</p>
							</div>
							<hr className={"stock-divider"}/>
							<div className={"d-flex align-items-end"}
							     onClick={() => initCancelOrder(orderOptions)}>
								<p className={"cancelText"}>Cancel Order</p>
								<img src={cancelArrow} alt={"alt"}/>
							</div>

						</div>

					</MDBModalBody>
				</MDBModal>
			</div>
		</div>
	)
};

const mapStateToProps = state => ({
	portfolioHoldingTab: state.FilterReducer.portfolioHoldingTab
})

const mapDispatchToProps = dispatch => ({
	setPorfolioHoldingTabToStore: (data) => dispatch(portfolioTabToggler(data))
})

export default connect(mapStateToProps, mapDispatchToProps)(HoldingsAndOrders)
